AuthRoute = require 'mixins/authenticated-route'
POLLING_INTERVAL = 10000

App.OrdersRoute = Em.Route.extend AuthRoute,
  enableCouriersPolling: false
  couriersPollingTimer: null

  env: Em.inject.service('environment')

  bonusEnabled: Em.computed.alias('env.features.bonusEnabled')

  onCouriersPollingChanged: (->
    if @get('enableCouriersPolling')
      @updateCouriers()
    else
      timer = @get('couriersPollingTimer')
      Em.run.cancel(timer)
  ).observes('enableCouriersPolling')


  setupController: (controller, model) ->
    @store.find('order').then (orders) =>
      controller.set('orders', orders)


  updateCouriers: ->
    @set('couriersPollingTimer', null)
    return if not @get('enableCouriersPolling')

    @store.find('courier', {}).then (couriers) =>

      positions = couriers
      # .map (c) =>
      #   p = c.getProperties('id', 'name', 'lat', 'lng', 'longAgoConnection', 'lostConnection')
      #   p

      controller = @controllerFor('orders')
      controller.set('courierPositions', positions)

      # pollingInterval = @get('env').get('courierPollingInterval') || 60 * 1000
      pollingInterval = 1 * 30 * 1000
      # Если в организации много курьеров, то обновляем их положения раз в 10 минут, иначе раз в 30 секунд
      if positions.length > 250
        pollingInterval = 10 * 60 * 1000

      # pollingInterval = 30 * 1000

      @set('couriersPollingTimer', Em.run.later(@, @updateCouriers, pollingInterval))


  afterModel: ->
    Em.RSVP.hash(
      restaurants:   @store.find('restaurant')
      couriers:      @store.find('courier')
      # zones:         @store.find('delivery_zone')
    ).then (attrs) =>
      @store.find('delivery_zone').then (zones) =>
        controller.set 'zones', zones
      controller = @controllerFor('orders')
      controller.setProperties(attrs)

  activate: ->
    @set('enableCouriersPolling', true)

  deactivate: ->
    @set('enableCouriersPolling', false)

  actions:
    showOrderModal: (order) ->
      path = @controllerFor('application').get('currentPath')

      if path.match /orders\.list.*/
        @transitionTo('orders.list.order', order)
      else
        @transitionTo('orders.map.order.detailed', order)
      false

    appendOrderToList: (order) ->
      controller = @controllerFor('orders.list')
      controller?.get('orders').unshiftObject( order )
      false

    removeOrderFromList: (order) ->
      @controllerFor('orders.list')?.get('orders')?.removeObject(order)
      @controllerFor('orders.map')?.get('orders')?.removeObject(order)
      false

    onSegmentChanged: (option) ->
      switch option
        when 'current' then @transitionTo('orders.map', queryParams: { f: 'current' })
        when 'delayed' then @transitionTo('orders.map', queryParams: { f: 'delayed' })
        when 'all' then @transitionTo('orders.list')
      false
